import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69408466e534c900144bc0f8_1784605037767_2989fbfc/diaax_advisory/src/app/privacy-policy/page.tsx");
